import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
// Styles
import styles from './styles';

import { push } from 'react-router-redux';
import { loginUser, getUser } from './service';
import { setAuth, setHeaders } from './helper';
import BookingStoreContext from '../../stores/bookingStore';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import clientLogo from '../../assets/LogoRideWhite.png';

function emailIsValid(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

// interface State {
//   name: string;
//   age: string;
//   multiline: string;
//   currency: string;
// }

const Login = props => {
  const bookingStore = React.useContext(BookingStoreContext);
  const { classes } = props;
  const [resultMessage, setResultMessage] = useState({
    isVisible: false,
    tittle: '',
    message: '',
  });
  const [user, setUser] = useState({
    email: '',
    password: '',
    isValidated: false,
    validEmail: false,
  });

  const submitLoginUser = async () => {
    if (user.isValidated === false) {
      setUser({ ...user, isValidated: true });
    }

    if (user.email && user.password && emailIsValid(user.email)) {
      const response = await loginUser(user);

      //* *200 authorized*/
      if (response && response.status === 200) {
        let headers = { 
          client: response.headers.client, 
          expiry: response.headers.expiry,
          uid: response.headers.uid,
          'access-token': response.headers['access-token']
        };
        setHeaders(headers);
        setAuth(response.data);
        const user = await getUser(response.data.user.id);
        if (user.status === 200) {
          if (user.data.role === 'collaborator' || user.data.role === 'driver') {
            bookingStore.setValue('isLoading', true);
            props.history.push('/requests/all');
            push('/requests/all');
          } else {
            props.history.push('/requests');
            push('/requests');
          }
        }
      }

      //* *401 Unauthorized*/
      if (response.status === 401) {
        setResultMessage({
          isVisible: true,
          tittle: 'Usuario no autorizado',
          message: 'Usuario no autorizado, Por favor revisar el nombre de usuario y contraseña',
        });
      }
    }
  };

  const handleInputEmail = e => {
    if (resultMessage.isVisible) {
      setResultMessage({ isVisible: true });
    }
    setUser({ ...user, email: e.target.value, validEmail: emailIsValid(e.target.value) });
  };

  return (
    <div className={classes.root}>
      <div className={classes.main}>
        <center>
          <img
            src={clientLogo}
            alt="Logo" className={classes.logo}
          />
        </center>
        <br />
        <br />
        <p className={classes.labelCaption}>Correo electrónico</p>
        <TextField
          id="email"
          className={classes.textField}
          type="text"
          margin="normal"
          inputProps={{
            'aria-label': 'bare'
          }}
          placeholder="Correo electrónico"
          value={user.email}
          onChange={handleInputEmail}
        />
        {user.isValidated &&
        !user.validEmail &&
        !(user.email === null || user.email === '' || user.email === undefined) ? (
          <p className={classes.validationLabel}>El email insertado no es correcto</p>
        ) : null}

        {user.isValidated &&
        (user.email === null || user.email === '' || user.email === undefined) ? (
          <p className={classes.validationLabel}>Por favor insertar un correo electrónico</p>
        ) : null}
        <br />
        <br />
        <p className={classes.labelCaption}>Contraseña</p>
        <TextField
          id="password"
          className={classes.textField}
          type="password"
          margin="normal"
          inputProps={{
            'aria-label': 'bare'
          }}
          placeholder="Contraseña"
          value={user.password}
          onChange={e => {
            setUser({ ...user, password: e.target.value });
          }}
        />
        {user.isValidated &&
        (user.password === null || user.password === '' || user.password === undefined) ? (
          <p className={classes.validationLabel}>Por favor insertar una clave</p>
        ) : null}
        <div className={classes.actions}>
          <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            onClick={() => {
              submitLoginUser();
            }}
          >
            ENTRAR
          </Button>
        </div>
        {resultMessage.isVisible ? (
          <p className={classes.validationLabel}>{resultMessage.message}</p>
        ) : null}
      </div>
    </div>
  );
};

export default withStyles(styles)(Login);
